import { styled } from '@mui/material'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import { colorPalette } from '../../../style/colorPalette'

export const DragHandle = ({
  isDragOverlay,
  setActivatorNodeRef,
  ...listeners
}: {
  isDragOverlay: boolean
  setActivatorNodeRef: (element: HTMLElement | null) => void
}) => {
  return (
    <Container
      isDragOverlay={!!isDragOverlay}
      ref={setActivatorNodeRef}
      {...listeners}
    >
      <DragIndicatorIcon sx={{ color: colorPalette.monotone[3] }} />
    </Container>
  )
}

const Container = styled('div')<{ isDragOverlay: boolean }>(props => ({
  cursor: 'grab',
  width: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: colorPalette.monotone[1],
  pointerEvents: props.isDragOverlay ? 'none' : 'auto',
}))
